module.exports = __webpack_public_path__ + "images/checkbox-selected76617fd087cd6db65c6c8987eda8e975.svg";